<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">App Notification Management</li>
                    </ol>
                </nav>
            </div>
            <h4 class="page-title">App Notification Management</h4>
        </div>

    </div>
</div>


<!-- ============================================================== -->








<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <div class="dataTables_length" id="zero_config_length">
                                        <label>Show
                                            <select name="zero_config_length" aria-controls="zero_config" class="form-control form-control-sm">
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select> entries</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <label>Search:
                                            <input type="search" class="form-control form-control-sm" placeholder="" aria-controls="zero_config">
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <table class="table product-overview v-middle dataTable no-footer" id="zero_config" role="grid" aria-describedby="zero_config_info">
                                        <thead style="background-color:#353556;color:white;font-size: 12px">
                                            <tr role="row">

                                                <th class="sorting_asc" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Customer: activate to sort column descending"
                                                    style="width: 0px;">User ID 


                                                </th>
                                                <th class="sorting_asc" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Customer: activate to sort column descending"
                                                    style="width: 0px;">User Email ID 
 

                                                </th>

                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-label="Photo: activate to sort column ascending"
                                                    style="width: 0px;">User Mobile 

                                                </th>
                                                
                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-label="Photo: activate to sort column ascending"
                                                    style="width: 0px;">Notification Type 


                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-label="Photo: activate to sort column ascending"
                                                    style="width: 0px;"> Notification Title 



                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-label="Photo: activate to sort column ascending"
                                                    style="width: 0px;"> Notification ID
                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-label="Photo: activate to sort column ascending"
                                                    style="width: 0px;">  Notification Text Description     
                                                </th>
                                               
                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1"
                                                    colspan="1" aria-label="Photo: activate to sort column ascending" style="width: 0px;">
                                                    Sent Time Stamp  
                                                </th>
                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1"
                                                colspan="1" aria-label="Photo: activate to sort column ascending" style="width: 0px;">
                                                Device ID 

                                            </th>
                                                <th class="sorting" tabindex="0" aria-controls="zero_config" rowspan="1" colspan="1" aria-label="Photo: activate to sort column ascending"
                                                    style="width: 0px;">  Received Time Stamp

                                                </th>

                                              
                                               
                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr role="row" class="odd">
                                                <td>1</td>
                                                <td>
                                                    hdfffff
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                               
                                                
                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    <div class="dataTables_info" id="zero_config_info" role="status" aria-live="polite">Showing 1 to 8 of 8 entries</div>
                                </div>
                                <div class="col-sm-12 col-md-7">
                                    <div class="dataTables_paginate paging_simple_numbers" id="zero_config_paginate">
                                        <ul class="pagination">
                                            <li class="paginate_button page-item previous disabled" id="zero_config_previous">
                                                <a href="#" aria-controls="zero_config" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                            </li>
                                            <li class="paginate_button page-item active">
                                                <a href="#" aria-controls="zero_config" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                                            </li>
                                            <li class="paginate_button page-item next disabled" id="zero_config_next">
                                                <a href="#" aria-controls="zero_config" data-dt-idx="2" tabindex="0" class="page-link">Next</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->